import React, { useState } from 'react'
import { Slider } from '@components'
import cn from 'classnames'
import * as st from '@assets/styl/testimonials.module.styl'
import { useLanguage } from '../hooks'
import play from '@assets/svg/play.svg'

export default () => {
  const { t } = useLanguage()
  const [visibleVideoId, setVisibleVideoId] = useState({})

  const handlePlayVideo = (index: number) => {
    setVisibleVideoId({
      [index]: !visibleVideoId[index],
    })
  }

  return (
    <section className={st.core}>
      <div>
        <div>
          <h3>{t('Testimonials.title')}</h3>
          <p>
            {t('Testimonials.paragraph')
              .split('\n')
              .map((line, index) => (
                <React.Fragment key={index}>
                  {line}
                  {index <
                    t('Testimonials.paragraph').split('\n').length - 1 && (
                    <br />
                  )}
                </React.Fragment>
              ))}
          </p>
        </div>
        <Slider classes={{ arrow: st.arrow }} dots>
          {[
            'jR5lh-xuXOA',       // nex novo
            'bgcpwlpw2MI',       // mys novo
            'wYbXwKYNOg8',       // garden novo
            'Nn6y30Qsw7s',       // spot novo
            'viO_FskcPCU',       // spot antigo
            'QyJYtWsWXiE',       // garden antigo
            'mXJkO0lMJFk',       // dimasExperience antigo
          ].map((videoId, index) => {
            const sourceVideo = `https://www.youtube.com/embed/${videoId}?autoplay=${
              visibleVideoId[index] ? '1' : '0'
            }`

            const keys = [
              'nex',
              'mys',
              'garden',
              'spot',
              'spot',
              'garden',
              'dimasExperience',
            ]

            const subKeys = [
              'clientTestimony',
              'clientTestimony',
              'clientTestimony',
              'dyardTestimony',
              'checkTestimonial',
              'visit',
              'seeCustomers',
            ]

            return (
              <div key={index} className={st.slide}>
                <div
                  className={cn({ hiddenImage: visibleVideoId[index] })}
                  onClick={() => handlePlayVideo(index)}
                >
                  <iframe
                    src={sourceVideo}
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    loading="lazy"
                  ></iframe>
                  <div className={st.play}>
                    <img
                      src={play}
                      width={105}
                      height={106}
                      alt="Botão Play"
                    />
                  </div>
                </div>
                <h4>{t(`Testimonials.${keys[index]}`)}</h4>
                <h5>{t(`Testimonials.${subKeys[index]}`)}</h5>
              </div>
            )
          })}
        </Slider>
      </div>
    </section>
  )
}
